import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { keyEmptyCheck } from 'aurora-utils/utils';
import withStyles from '@material-ui/core/styles/withStyles';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import Radio from '@material-ui/core/Radio';
import Divider from '@material-ui/core/Divider';
import Hidden from '@material-ui/core/Hidden';
import classNames from 'classnames';
import ADGMItemDetails from 'aurora-components/ADGMItemDetails/ADGMItemDetails';
import ADGMImage from '../../../ADGMImage';
import StatusChip from './StatusChip';
import styles from './styles';

function ContractCard({ classes, contract, entities, labels, footer, hideContractDetailsBtn, selected, selectable }) {
  const locale = localStorage.getItem('lang');
  return (
    <div className={classes.listItemText}>
      <Box className={classes.contractCardTop}>
        <Box className={classes.itemTitle}>
          <Box display='flex' alignItems='center'>
            {selectable && (
              <Radio
                edge='start'
                checked={selected?.contractId === contract?.contractId || false}
                tabIndex={-1}
                disableRipple
                inputProps={{ 'aria-labelledby': contract?.contractId }}
                classes={{ root: classes.itemCheckbox, checked: classes.itemCheckboxChecked }}
              />
            )}
            <Typography variant='body1' component='h3'>
              {keyEmptyCheck('contract_number')} : {contract?.contractNumber}
            </Typography>
          </Box>
          {contract?.contractStatus && (
            <Hidden smDown>
              <StatusChip status={contract?.contractStatus} />
            </Hidden>
          )}
        </Box>
        <Box className={classes.contractDetails}>
          {entities?.map(({ label, value }) => (
            <Box sx={{ display: 'flex', alignItems: 'end' }} key={label}>
              <Box mt={1} mr={1}>
                <ADGMImage name='user_icon-green.svg' alt='bank' />
              </Box>
              <Box>
                <ADGMItemDetails valueClass={classes.body1_d} label={label} value={value} />
              </Box>
            </Box>
          ))}
        </Box>
      </Box>
      <Divider className={classes.divider} />
      <Box className={classes.contractCardBottom}>
        <Box className={classes.contractDetails}>
          {labels?.map(({ label, value, smDownHidden, ...props }) => {
            if (smDownHidden)
              return (
                <Hidden smDown>
                  <Box>
                    <ADGMItemDetails valueClass={classes.body1_d} label={label} value={value} {...props} />
                  </Box>
                </Hidden>
              );
            return (
              <Box>
                <ADGMItemDetails valueClass={classes.body1_d} label={label} value={value} {...props} />
              </Box>
            );
          })}
        </Box>

        {!hideContractDetailsBtn && (
          <Box alignSelf='end' className={classes.contractLink}>
            {keyEmptyCheck('contract_details')}{' '}
            <ADGMImage
              name='angleRight.svg'
              alt='RightArrowIcon'
              className={classNames({
                [classes.rotateY180]: locale === 'ar',
              })}
            />
          </Box>
        )}
      </Box>

      <Hidden mdUp>
        <div className={classes.itemFooter}>
          <div className={classes.footerDates}>
            {footer?.map(({ label, value }) => (
              <Fragment key={label}>
                <Typography variant='body1'>{keyEmptyCheck(label)} :</Typography>
                <Typography variant='body1'>{value}</Typography>
              </Fragment>
            ))}
          </div>
          {contract?.contractStatus && <StatusChip status={contract?.contractStatus} />}
        </div>
      </Hidden>
    </div>
  );
}

ContractCard.propTypes = {
  classes: PropTypes.object.isRequired,
  contract: PropTypes.object.isRequired,
  entities: PropTypes.array.isRequired,
  labels: PropTypes.array.isRequired,
  footer: PropTypes.array.isRequired,
  hideContractDetailsBtn: PropTypes.bool,
  selected: PropTypes.object.isRequired,
  selectable: PropTypes.bool.isRequired,
};

ContractCard.defaultProps = {
  hideContractDetailsBtn: false,
};

export default withStyles(styles)(ContractCard);
